import "bootstrap/dist/css/bootstrap.min.css";
import "rsuite/dist/rsuite.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { restoreDocumentStyles } from "./utils/documentStyles";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./scss/index.scss";
import { Toaster } from "react-hot-toast";

restoreDocumentStyles();

if (process.env.REACT_APP_ENV === 'production') {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Toaster position="top-right" containerClassName="Toastify" />
       <App />
    </BrowserRouter>
  </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
